import React, { useEffect, useState } from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Avatar,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { getSarpanchDetails, updateSarpanchDetails } from "../../api/User";

import { ToastContainer, toast } from "react-toastify";

function SarpanchDetails() {
  const [open, setOpen] = useState(false);
  const [selectedPerson, setSelectedPerson] = useState({});
  const [formData, setFormData] = useState({
    id: "",
    name: "",
    role: "",
    mobile_number: "",
    email: "",
    address: "",
    block: "",
    gram_panchayat: "",
    panchayat_website: "",
    other_website: "",
    file: "",
  });
  const [update, setUpdate] = useState(false);
  const user_id = sessionStorage.getItem("user_id");
  const token = sessionStorage.getItem("token");
  const [sarpanchDetails, setSarpanchDetails] = useState([]);
  const [imagePreview, setImagePreview] = useState(null);
  const [errors, setErrors] = useState({
    name: "",
    mobile_number: "",
    email: "",
    address: "",
    panchayat_website: "",
    other_website: "",
  });

  const handleOpen = (person, id) => {
    setSelectedPerson(person, id);
    setFormData({
      id: id,
      name: person.name,
      role: person.designation,
      mobile_number: person.mobile_number,
      email: person.email,
      address: person.address,
      block: person.block,
      gram_panchayat: person.gram_panchayat,
      panchayat_website: person.panchayat_website,
      other_website: person.other_website,
    });
    setOpen(true);
  };
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const phoneRegex = /^[6-9][0-9]{9}$/;
  const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;




  const handleClose = () => {
    setOpen(false);
    setSelectedPerson(null);
    setUpdate(false);
    setImagePreview(null);
    setErrors({});
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSelectedPerson({
      ...selectedPerson,
      [name]: name == "name" ? value.toUpperCase() : value.toUpperCase(),
      [name]: name == "address" ? value.toUpperCase() : value.toUpperCase(),
    });
    if (value) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
    }
    if (name == "email" && !emailRegex.test(value)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        email: "Invalid email address",
      }));
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        email: "",
      }));
    }
    if (name == "phone" && !phoneRegex.test(value)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        mobile_number: "Invalid mobile address",
      }));
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        mobile_number: "",
      }));
    }
    if (name == "panchayat_website" && !urlRegex.test(value)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        panchayat_website: "Invalid website format. ",
      }));
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        panchayat_website: "",
      }));
    }
    if (name == "other_website") {
      if (value && !urlRegex.test(value)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          other_website: "Invalid website format.",
        }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          other_website: "",
        }));
      }
    }

  };

  const handleImageUpload = (e) => {
    setImagePreview(URL.createObjectURL(e.target.files[0]));
    setSelectedPerson({
      ...selectedPerson,
      file: e.target.files[0],
    });
  };
  const handleUpdate = () => {
    setUpdate(true);
  };
  const handleCancelUpdate = () => {
    setUpdate(false);
    setImagePreview(null);
    fetchData();
    handleClose()
  };
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await getSarpanchDetails(token, user_id);
      setSarpanchDetails(res.data.result);
    } catch (error) {
      console.error("Error fetching profile data:", error);
    }
  };
  const imageSrc = (data) => {
    if (data) {
      return `data:image/jpeg;base64,${data}`;
    }
    return "";
  };

  // const handleSave = async () => {
  //   const newErrors = {};

  //   Object.keys(selectedPerson).forEach((key) => {
  //     if (!selectedPerson[key] && key !== "other_website") {
  //       newErrors[key] = `Field cannot be empty`;
  //     } else if (errors[key]) {
  //       newErrors[key] = "";
  //     }
  //   });

  //   if (Object.keys(newErrors).some((key) => newErrors[key])) {
  //     setErrors(newErrors);
  //     return;
  //   }
  //   if (!emailRegex.test(selectedPerson.email)) {
  //     setErrors((prevErrors) => ({
  //       ...prevErrors,
  //       email: "Invalid email address",
  //     }));
  //     return;
  //   }
  //   if (!phoneRegex.test(selectedPerson.mobile_number)) {
  //     setErrors((prevErrors) => ({
  //       ...prevErrors,
  //       mobile_number: "Invalid mobile number",
  //     }));
  //     return;
  //   }
  //   if (errors.panchayat_website !="") {
  //     return;
  //   }
  //   if (selectedPerson.panchayat_website && !urlRegex.test(selectedPerson.panchayat_website)) {
  //     setErrors((prevErrors) => ({
  //       ...prevErrors,
  //       panchayat_website: "Invalid website format.",
  //     }));
  //     return;
  //   }
  //   if (selectedPerson.other_website && !urlRegex.test(selectedPerson.other_website)) {
  //     setErrors((prevErrors) => ({
  //       ...prevErrors,
  //       other_website: "Invalid website format.",
  //     }));
  //     return;
  //   }

  //   try {
  //     const formData = new FormData();
  //     Object.keys(selectedPerson).forEach((key) => {
  //       formData.append(key, selectedPerson[key]);
  //     });

  //     const res = await updateSarpanchDetails(token, formData);
  //     setUpdate(false);
  //     fetchData();
  //     handleClose();
  //     setImagePreview(null);
  //     toast.success(res.message);
  //   } catch (error) {
  //     console.error("Error updating profile:", error);
  //     toast.error("Failed to update profile. Please try again.");
  //   }
  // };

  const handleSave = async () => {
    const newErrors = {};

    Object.keys(selectedPerson).forEach((key) => {
      if (!selectedPerson[key] && key !== "other_website") {
        newErrors[key] = `Field cannot be empty`;
      }
    });

    if (!emailRegex.test(selectedPerson.email)) {
      newErrors.email = "Invalid email address";
    }

    if (!phoneRegex.test(selectedPerson.mobile_number)) {
      newErrors.mobile_number = "Invalid mobile number";
    }


    if (errors.panchayat_website != "") {
      return;
    }

    if (selectedPerson.other_website && !urlRegex.test(selectedPerson.other_website)) {
      newErrors.other_website = "Invalid website format.";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      const formData = new FormData();
      Object.keys(selectedPerson).forEach((key) => {
        formData.append(key, selectedPerson[key]);
      });

      const res = await updateSarpanchDetails(token, formData);
      setUpdate(false);
      fetchData();
      handleClose();
      setImagePreview(null);
      toast.success(res.message);
    } catch (error) {
      console.error("Error updating profile:", error);
      toast.error("Failed to update profile. Please try again.");
    }
  };

  const handleKeyPress = (e) => {
    const char = String.fromCharCode(e.which);
    if (!/[a-zA-Z\s]/.test(char)) {
      e.preventDefault();
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <Typography variant="h4" gutterBottom style={{ marginBottom: "30px", fontWeight: "600" }}>
        Sarpanch Details
      </Typography>

      <div style={{ maxHeight: "75vh", overflowY: "auto" }}>


        <Grid container spacing={4} style={{ marginBottom: "10px", padding: "5px" }}>
          {sarpanchDetails?.map((person) => (
            <Grid item xs={12} sm={6} md={4} key={person.id}>
              <Card elevation={3} style={{ borderRadius: 10 }}>
                <CardContent>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginBottom: 16,
                    }}
                  >
                    <Avatar
                      alt={person.name}
                      src={imageSrc(person.gram_sachiv_photo_base64)}
                      sx={{ width: 90, height: 90 }}
                    />
                  </div>
                  <Typography variant="h6" align="center" gutterBottom>
                    {person.name}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    align="center"
                    gutterBottom
                  >
                    {person.role}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    align="center"
                  >
                    {person.gram_panchayat}
                  </Typography>
                  <Typography variant="body2" align="center" gutterBottom>
                    {person.mobile_number}
                  </Typography>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <Button
                      variant="text"
                      color="primary"
                      onClick={() => handleOpen(person, person.id)}
                    >
                      View Details
                    </Button>
                  </div>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </div>

      <Dialog open={open} onClose={handleClose} style={{ overflowX: "hidden" }}>
        <DialogTitle>
          {/* {selectedPerson?.name} */}
          <IconButton
            aria-label="close"
            onClick={handleClose}
            style={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent style={{ width: "28vw" }}>
          {selectedPerson && (
            <div style={{ overflowX: "hidden" }}>
              {imagePreview ? (
                <Avatar
                  alt={selectedPerson.name}
                  src={imagePreview}
                  sx={{ width: 100, height: 100, marginBottom: 2 }}
                />
              ) : (
                <Avatar
                  alt={selectedPerson.name}
                  src={imageSrc(selectedPerson.gram_sachiv_photo_base64)}
                  sx={{ width: 100, height: 100, marginBottom: 2 }}
                />
              )}
              <input
                type="file"
                accept="image/*"
                name="file"
                onChange={handleImageUpload}
                disabled={!update}
                style={{ marginBottom: "10px" }}
              />

              {/* <TextField
                label="Name"
                name="name"
                defaultValue={formData.name}
                onChange={handleChange}
                fullWidth
                margin="normal"
                disabled={!update}
                InputProps={{
                  style: { textTransform: 'uppercase' } 
                }}
              /> */}
              <div className="col">
                <label
                  htmlFor="name"
                  className="form-label"
                  style={{ fontWeight: "bold" }}
                >
                  Name <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.name ? "is-invalid" : ""}`}
                  id="name"
                  name="name"
                  defaultValue={formData.name}
                  disabled={!update}
                  style={{ textTransform: "uppercase" }}
                  onChange={handleChange}
                  onKeyPress={handleKeyPress}
                />
                {errors.name && (
                  <div className="invalid-feedback">{errors.name}</div>
                )}
              </div>
              {/* <TextField
                label="Role"
                name="role"
                defaultValue={formData.role}
                onChange={handleChange}
                fullWidth
                margin="normal"
                disabled
                
              /> */}
              <div className="col">
                <label
                  htmlFor="name"
                  className="form-label"
                  style={{ fontWeight: "bold" }}
                >
                  Role <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.role ? "is-invalid" : ""}`}
                  id="role"
                  name="role"
                  defaultValue={formData.role}
                  disabled
                  style={{ textTransform: "uppercase" }}
                  onChange={handleChange}
                />
              </div>
              {/* <TextField
                label="Block"
                name="block"
                value={formData.block}
                onChange={handleChange}
                fullWidth
                margin="normal"
                disabled
              /> */}
              <div className="col">
                <label
                  htmlFor="name"
                  className="form-label"
                  style={{ fontWeight: "bold" }}
                >
                  Block <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.block ? "is-invalid" : ""}`}
                  id="block"
                  name="block"
                  defaultValue={formData.block}
                  disabled
                  style={{ textTransform: "uppercase" }}
                  onChange={handleChange}
                />
              </div>
              {/* <TextField
                label="Gram Panchayat Name"
                name="gram_panchayat"
                value={formData.gram_panchayat}
                onChange={handleChange}
                fullWidth
                margin="normal"
                disabled
              /> */}
              <div className="col">
                <label
                  htmlFor="name"
                  className="form-label"
                  style={{ fontWeight: "bold" }}
                >
                  Gram Panchayat <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="gram_panchayat"
                  name="gram_panchayat"
                  defaultValue={formData.gram_panchayat}
                  disabled
                  style={{ textTransform: "uppercase" }}
                  onChange={handleChange}
                />
              </div>
              {/* <TextField
                label="Mobile Number"
                name="mobile_number"
                defaultValue={formData.mobile_number}
                onChange={handleChange}
                fullWidth
                margin="normal"
                disabled={!update}
              /> */}
              <div className="col">
                <label
                  htmlFor="mobile_number"
                  className="form-label"
                  style={{ fontWeight: "bold" }}
                >
                  Mobile Number <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.mobile_number ? "is-invalid" : ""}`}
                  id="mobile_number"
                  name="mobile_number"
                  min={0}
                  maxLength={10}
                  defaultValue={formData.mobile_number}
                  disabled={!update}
                  onChange={handleChange}
                />
                {errors.mobile_number && (
                  <div className="invalid-feedback">{errors.mobile_number}</div>
                )}
              </div>
              {/* <TextField
                label="Email"
                name="email"
                defaultValue={formData.email}
                onChange={handleChange}
                fullWidth
                margin="normal"
                disabled={!update}
              /> */}
              <div className="col">
                <label
                  htmlFor="name"
                  className="form-label"
                  style={{ fontWeight: "bold" }}
                >
                  Email <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.email ? "is-invalid" : ""}`}
                  id="email"
                  name="email"
                  defaultValue={formData.email}
                  disabled={!update}
                  style={{ textTransform: "lowercase" }}
                  onChange={handleChange}
                />
                {errors.email && (
                  <div className="invalid-feedback">{errors.email}</div>
                )}
              </div>
              {/* <TextField
                label="Address"
                name="address"
                defaultValue={formData.address}
                onChange={handleChange}
                fullWidth
                margin="normal"
                disabled={!update}
                InputProps={{
                  style: { textTransform: "uppercase" },
                }}
              /> */}
              <div className="col">
                <label
                  htmlFor="name"
                  className="form-label"
                  style={{ fontWeight: "bold" }}
                >
                  Address <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.address ? "is-invalid" : ""}`}
                  id="address"
                  name="address"
                  defaultValue={formData.address}
                  disabled={!update}
                  style={{ textTransform: "uppercase" }}
                  onChange={handleChange}
                />
                {errors.address && (
                  <div className="invalid-feedback">{errors.address}</div>
                )}
              </div>

              {/* <TextField
                label="Panchayat Website"
                name="panchayat_website"
                defaultValue={formData.panchayat_website}
                onChange={handleChange}
                fullWidth
                margin="normal"
                disabled={!update}
              /> */}
              <div className="col">
                <label
                  htmlFor="name"
                  className="form-label"
                  style={{ fontWeight: "bold" }}
                >
                  Panchayat Website <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.panchayat_website ? "is-invalid" : ""}`}
                  id="panchayat_website"
                  name="panchayat_website"
                  defaultValue={formData.panchayat_website}
                  disabled={!update}
                  style={{ textTransform: "lowercase" }}
                  placeholder="https://www.example.com"
                  onChange={handleChange}
                />
                {errors.panchayat_website && (
                  <div className="invalid-feedback">
                    {errors.panchayat_website}
                  </div>
                )}
              </div>
              {/* <TextField
                label="Other Website"
                name="other_website"
                defaultValue={formData.other_website}
                onChange={handleChange}
                fullWidth
                margin="normal"
                disabled={!update}
              /> */}
              <div className="col">
                <label
                  htmlFor="name"
                  className="form-label"
                  style={{ fontWeight: "bold" }}
                >
                  If Any Other Website (optional)
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.other_website ? "is-invalid" : ""}`}
                  id="other_website"
                  name="other_website"
                  defaultValue={formData.other_website}
                  disabled={!update}
                  style={{ textTransform: "lowercase" }}
                  placeholder="https://www.example.com"
                  onChange={handleChange}
                />
                {errors.other_website && (
                  <div className="invalid-feedback">{errors.other_website}</div>
                )}
              </div>
            </div>
          )}
        </DialogContent>
        <div className="d-flex justify-content-center mb-2 mt-2">
          {!update ? (
            <button
              className="btn"
              onClick={handleUpdate}
              style={{
                width: "35%",
                backgroundColor: "#4763E430",
                color: "#4763E4",
                border: "none",
                padding: "10px 20px",
                borderRadius: "4px",
                cursor: "pointer",
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = "#4763E4";
                e.target.style.color = "#fff";
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = "#4763E430";
                e.target.style.color = "#4763E4";
              }}
            >
              Update Sarpanch
            </button>

          ) : (
            <>
              <button
                type="button"
                className="btn me-2"
                onClick={handleSave}
                style={{
                  width: "20%",
                  backgroundColor: "#4763E430",
                  color: "#4763E4",
                  border: "none",
                  padding: "10px 20px",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = "#4763E4";
                  e.target.style.color = "#fff";
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = "#4763E430";
                  e.target.style.color = "#4763E4";
                }}
              >
                Save
              </button>

              <button
                type="reset"
                className="btn"
                onClick={handleCancelUpdate}
                style={{
                  width: "20%",
                  backgroundColor: "#4763E430",
                  color: "#4763E4",
                  border: "none",
                  padding: "10px 20px",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = "#4763E4";
                  e.target.style.color = "#fff";
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = "#4763E430";
                  e.target.style.color = "#4763E4";
                }}
              >
                Cancel
              </button>

            </>
          )}
        </div>
      </Dialog>
      <ToastContainer />

    </div>
  );
}

export default SarpanchDetails;
